module.exports = __webpack_public_path__ + "d655b563cfb784361182b5421d5bcaab.svg";